module.exports = __webpack_public_path__ + "static/img/presysv21.343030a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv21.png
// module id = aObj
// module chunks = 1